import type { router } from '@inertiajs/react';

import type { SdkRouter } from './types';

export type RouterLike = Pick<
  typeof router,
  'visit' | 'get' | 'post' | 'put' | 'patch' | 'delete' | 'reload'
>;

export function createRouter(router: RouterLike): SdkRouter {
  // Each method delegates to the Inertia router and returns void, matching the
  // SdkRouter contract — statement bodies (not implicit returns) so the router's
  // return value is never leaked through a void-typed surface.
  return {
    visit: (url, options) => {
      router.visit(url, options);
    },
    get: (url, data, options) => {
      router.get(url, data as Parameters<RouterLike['get']>[1], options);
    },
    post: (url, data, options) => {
      router.post(url, data as Parameters<RouterLike['post']>[1], options);
    },
    put: (url, data, options) => {
      router.put(url, data as Parameters<RouterLike['put']>[1], options);
    },
    patch: (url, data, options) => {
      router.patch(url, data as Parameters<RouterLike['patch']>[1], options);
    },
    delete: (url, options) => {
      router.delete(url, options);
    },
    reload: (options) => {
      router.reload(options);
    }
  };
}
